import React from "react";

export default function Pagination({
    paginationItemsCount = 6,
    currentPage,
    totalPages,
    onPageSelected,
    onNextPage,
    onPreviousPage,
}) {
    function navigateToPreviousPage() {
        if (currentPage > 0) onPreviousPage();
    }

    function navigateToNextPage() {
        if (currentPage < totalPages - 1) onNextPage();
    }

    function navigateToPage(page) {
        if (currentPage !== page) onPageSelected(page);
    }

    const startIndex = Math.max(0, currentPage - paginationItemsCount / 2);
    const endIndex = Math.min(totalPages - 1, startIndex + paginationItemsCount - 1);

    return (
        <ul
            className="d-flex align-items-center p-0 flex-wrap"
            style={{ listStyle: "none", gap: 16 }}
        >
            <li onClick={navigateToPreviousPage} role="button">
                <div
                    className="pagination-nav-btn"
                    style={{
                        rotate: "-90deg",
                        cursor: currentPage ? "pointer" : "default",
                    }}
                >
                    <img
                        src={`/images/icon/${currentPage ? "black" : "gray"}-up-chevron.svg`}
                        alt="chevron up"
                    />
                </div>
            </li>

            {Array.from({ length: endIndex - startIndex + 1 }, (_, index) => (
                <li
                    key={index}
                    className={`pagination-page-item ${
                        startIndex + index === currentPage ? "pagination-page-item-active" : ""
                    }`}
                    role="button"
                    onClick={() => navigateToPage(startIndex + index)}
                >
                    {startIndex + index + 1}
                </li>
            ))}

            <li onClick={navigateToNextPage} role="button">
                <div
                    className="pagination-nav-btn"
                    style={{
                        rotate: "90deg",
                        cursor: currentPage !== totalPages - 1 ? "pointer" : "default",
                    }}
                >
                    <img
                        src={`/images/icon/${
                            currentPage !== totalPages - 1 ? "black" : "gray"
                        }-up-chevron.svg`}
                        alt="chevron up"
                    />
                </div>
            </li>
        </ul>
    );
}
